export default "__VITE_ASSET__bd6fc80b__"